import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { handleFieldChange } from "../../../../Utils";
import FormOverlay from '../../../../components/FormOverlay';
import SelectWrap from '../../../../components/SelectWrap';
import Icon from '../../../../components/Icon';
import countriesOptions from "../../../../data/countries";

class Form extends Component {
    constructor(props) {
        super(props);

        if(this.props.source) {
            const { source } = this.props;

            this.state = {
                update: !this.props.duplicate,
                name: source.name,
                type: source.type,
                countries: source.countries
            };
        }
        else {
            this.state = {
                name: '',
                types: '',
                countries: ''
            };
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();

        this.props.onSubmit(Object.assign({}, this.state));
    }

    render() {
        return (
            <FormOverlay onFormHide={this.props.onFormHide}>
                <form onSubmit={this.handleSubmit} style={{ height: "auto", maxWidth: "600px" }}>
                    <SelectWrap
                        value={this.state.name}
                        name="name"
                        label="Source:"
                        values={this.props.availableSources}
                        onChange={this.handleFieldChange}
                        required
                    />
                    <SelectWrap
                        value={this.state.type}
                        name="type"
                        label="Type:"
                        values={{ include: 'Include', exclude: 'Exclude' }}
                        onChange={this.handleFieldChange}
                    />
                    <SelectWrap
                        values={countriesOptions}
                        label="Countries:"
                        name="countries"
                        onChange={this.handleFieldChange}
                        value={this.state.countries}
                        multi
                    />
                    <Button className="pull-right" bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>
                </form>
            </FormOverlay>
        );
    }
}

export default Form;


// WEBPACK FOOTER //
// ./src/scenes/BidderSourcesCountry/components/Form/index.js